import { Component, ElementRef, Input, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import {
  ApplicationState,
  getExceedingAmountState,
} from '../../../store/reducers';
import { OnDestroyHookDirective } from '../../../shared/hooks';
import * as ExceedingAmountActions from '../../../store/actions/exceeding-amount.actions';
import {
  ExceedingAmount,
  getType,
  isResCustomer,
  isB2B2ECustomer,
  Product,
  ProductTypes,
} from '@dch/products-business-logic';
import { CustomerService, InceptionService } from '@proximus/ng-common';

@Component({
  selector: 'mprd-exceeding-amount',
  templateUrl: './exceeding-amount.component.html',
})
export class ExceedingAmountComponent
  extends OnDestroyHookDirective
  implements OnInit
{
  public exceedingAmount: number;

  @Input() product: Product;
  @Input() overriddenClasses: string;

  constructor(
    private _store: Store<ApplicationState>,
    private inceptionService: InceptionService,
    private element: ElementRef,
    private customerService: CustomerService,
  ) {
    super();
  }

  ngOnInit() {
    const type = getType(this.product);
    if (this.shouldSubscribe(type)) {
      this._store.dispatch(
        new ExceedingAmountActions.GetExceedingAmount({
          serviceId: this.product.accessNumber,
          type,
        }),
      );
      this.addSubscription(
        this._store
          .select(getExceedingAmountState)
          .subscribe((data: ExceedingAmount[]) => {
            const exceedingAmount = data.find(
              (value) =>
                value.serviceId === this.product.accessNumber &&
                type === value.type,
            );
            if (exceedingAmount) {
              this.customerService
                .getCustomerAccount()
                .subscribe((customerAccount) => {
                  const amount =
                    isResCustomer(customerAccount) ||
                    isB2B2ECustomer(customerAccount)
                      ? exceedingAmount.amountInclVAT
                      : exceedingAmount.amountExclVAT;
                  if (amount > 0) {
                    this.exceedingAmount = amount;
                  }
                });
              setTimeout(() => this.inceptionService.rsTooltip(this.element));
            }
          }),
      );
    }
  }

  private shouldSubscribe(type: ProductTypes): boolean {
    return [
      ProductTypes.TV,
      ProductTypes.TELEPHONY,
      ProductTypes.MOBILE_BONE,
      ProductTypes.MOBILE_MCS,
    ].includes(type);
  }
}
